import { createAsyncSliceWithData } from '../createAsyncSliceWithData';
import { getAllClientsAsync } from 'API/clients/ClientsAPI';

export const { slice: clientsSlice, asyncAction: getAllClientsAsyncAction } = createAsyncSliceWithData(
  'clients',
  getAllClientsAsync,
  []
);
